import moment from 'moment'
import * as momentTz from 'moment-timezone'
import type { ExtendedPrimitives } from '../ExtendedPrimitives'

export type EventCreateModel = {
    client_id: number
    comments: string

    end_at: Date | string
    name: string
    start_at: Date | string
    partner_config?: Record<string, ExtendedPrimitives> | undefined
    partner_id?: number
    tz: string
}

export const defaultEventCreateModel = {
    client_id: 0,
    comments: '',
    start_at: moment().startOf('d').utc().toDate(),
    end_at: moment().endOf('d').utc().add(1, 'd').toDate(),
    name: '',
    tz: momentTz.tz.guess()
}
